import { BACKEND_BASE } from "@/lib/backend";

/** Resolve CMS / API media paths against the configured backend origin. */
export function resolveMediaUrl(url) {
  const raw = (url || "").trim();
  if (!raw) return "";
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  if (raw.startsWith("/api/")) return `${BACKEND_BASE}${raw}`;
  return raw;
}
